"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// checks if the persons step is valid and if cabins are available
function personsStepValid(_state, getters) {
    var cabinsAvailable = true;
    if (getters['cabins/fetchCategoriesDone']) {
        if (getters['generalCruise'] && (getters['generalCruise'].priceModel === 'JUST' ||
            getters['generalCruise'].priceModel === 'PAUSCHAL')) {
            cabinsAvailable = (getters['cabins/availableNormalCabinCategories'].length > 0);
        }
        else {
            cabinsAvailable = (getters['cabins/availableMainCabinCategories'].length > 0 ||
                getters['cabins/availablePremiumCabinCategories'].length > 0 ||
                getters['cabins/availablePremiumAICabinCategories'].length > 0);
        }
    }
    return getters['persons/isValid'] && cabinsAvailable;
}
exports.default = personsStepValid;
//# sourceMappingURL=persons_step_valid.js.map